// @ts-nocheck
import "babel-polyfill";
import * as React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import {CacheProvider} from '@emotion/react'
import AppRouter from "./routes";
const appDom = document.getElementById("app");
import createCache from '@emotion/cache';
import reduxStore from './store';
const myCache = createCache({
    nonce:Window.MUII
})
const stack = (
<CacheProvider value={myCache} >
    <Provider store={reduxStore}>
        <RouterProvider router={AppRouter}/>
    </Provider>
</CacheProvider>
);

const root = ReactDOM.createRoot(appDom);

root.render(stack);
